import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core'
import { useEffect, useState } from 'react'

import Loading from '@/components/loading'
import { useGetHerbicideTreatments } from '@/hooks/queries/use-get-herbicide-treatments'
import {
  BaseInputItem,
  BaseInputItemProps,
} from '@/pages/diagnosis-view/components/base-input-item'
import { HerbicideTreatment } from '@/services/get-herbicide-treatments'

import { useStyles } from './styles'

interface InputItemProps extends BaseInputItemProps {
  herbicideTreatment?: HerbicideTreatment | null
  onSelectedHerbicideTreatment: (
    herbicideTreatment?: HerbicideTreatment | null,
  ) => void
}

export function InputItem({
  herbicideTreatment,
  name,
  bgColor,
  border,
  onSelectedHerbicideTreatment,
}: InputItemProps) {
  const classes = useStyles()

  const [value, setValue] = useState(() => {
    if (herbicideTreatment === null) return 'no-option'
    if (herbicideTreatment) return herbicideTreatment.id

    return ''
  })

  const { data, isLoading } = useGetHerbicideTreatments()

  function onValueChange() {
    if (!value) return onSelectedHerbicideTreatment()

    if (herbicideTreatment?.id === value) return

    if (value === 'no-option') return onSelectedHerbicideTreatment(null)

    onSelectedHerbicideTreatment(data?.find((item) => item.id === value))
  }

  useEffect(() => {
    setTimeout(() => {
      onValueChange()
    }, 100)
  }, [value])

  return (
    <BaseInputItem name={name} bgColor={bgColor} border={border}>
      <FormControl variant='filled' color='secondary' hiddenLabel size='small'>
        {!value && (
          <InputLabel id='select-herbicide-treatment-input-label'>
            Selecionar tratamento
          </InputLabel>
        )}
        <Select
          className={classes.select}
          labelId='select-herbicide-treatment-input-label'
          value={value}
          MenuProps={{
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            getContentAnchorEl: null,
          }}
          disableUnderline
          IconComponent={
            isLoading
              ? () => (
                  <Loading
                    className={classes.loadingSelect}
                    size='1.8rem'
                    color='secondary'
                  />
                )
              : undefined
          }
          onChange={(e) => setValue(e.target.value as string)}
        >
          <MenuItem value='no-option'>- Não utilizar tratamento -</MenuItem>
          <Divider className={classes.divider} />
          {data?.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.treatment_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {value && (
        <ul className={classes.herbicidesContainer}>
          {data
            ?.find((i) => i.id === value)
            ?.herbicides.map((herbicide) => (
              <li key={herbicide.id}>
                <Typography>
                  <span>{herbicide.herbicide_name}</span> | Dose:{' '}
                  {herbicide.herbicide_dose}
                </Typography>
              </li>
            ))}
        </ul>
      )}
    </BaseInputItem>
  )
}
